import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

class SelectContactosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: '',
    };

    this.buscarContactos = debounce(this.buscarContactos.bind(this), 300);
  }

  componentDidMount() {
    this.buscarContactos('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      if(this.props.value){
        const buscarContacto = this.state.opciones.find(c => c._id.toString() === this.props.value.toString());
        if (!buscarContacto){
          this.buscarContactos(this.props.value || '', true);
        }
      }
    }
  }

  async buscarContactos(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "contactos/selectContactosItem", 
        {
          query: append ? (this.state.texto || texto || this.props.value) : (texto || this.props.value),
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState((prev) => ({
          opciones: append ? [...prev.opciones, ...res.data.contactos] : res.data.contactos,
          primerCarga: false,
          texto: append ? this.state.texto : texto
        }));
        
        if(this.props.autoseleccionar && inicial && res.data.contactos.length > 0) {
          if (this.props.onChange) {
             this.props.onChange(res.data.contactos[0]._id, res.data.contactos[0]);
          }
        }
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar contactos:", error);
      this.setState({ opciones: [], texto: append ? this.state.texto : texto });
    } finally {
      this.setState({ cargando: false, texto: append ? this.state.texto : texto });
    }
  }

  render() {
    const {
      noBuscar,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false, 
      onSearch: this.buscarContactos,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando contactos...
          </div>
        </div>
      ) : this.state.primerCarga ? 'Cargando...' : 'No se encontraron contactos',
      loading: this.state.cargando,
    };

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || '100%',
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const contacto = this.state.opciones.find((c) => c._id === value);
          if(this.props.onChange) this.props.onChange(value, contacto);
        }}
        placeholder={this.state.cargando && this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarContactos(this.props.value || '', false, true);
          }
        }}
      >
        {this.state.opciones.map((contacto) => (
          <Option key={contacto._id} value={contacto._id}>
            {contacto.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectContactosItem;